/**
 * Interceptor global para reemplazar automáticamente todas las imágenes de WordPress
 * con URLs del proxy para evitar problemas de CORS
 */
const wordpressDomain = 'smartcityexposantiagodelestero.com';
const getProxyBaseUrl = (): string => {
  let apiBaseUrl = process.env.REACT_APP_API_URL || '';
  
  // Si apiBaseUrl está vacío, usar window.location.origin
  if (!apiBaseUrl) {
    apiBaseUrl = window.location.origin;
  }
  
  // Normalizar: eliminar /api al final si existe para evitar duplicación
  apiBaseUrl = apiBaseUrl.replace(/\/api\/?$/, '');
  
  return apiBaseUrl;
};
/**
 * Reemplaza la URL de una imagen de WordPress con la URL del proxy
 */
const getProxyUrl = (originalUrl: string): string => {
  // No procesar URLs blob o data (son locales y no necesitan proxy)
  if (!originalUrl || originalUrl.startsWith('blob:') || originalUrl.startsWith('data:')) {
    return originalUrl;
  }
  if (!originalUrl.includes(wordpressDomain) || originalUrl.includes('/api/proxy-image')) {
    return originalUrl;
  }
  const proxyBaseUrl = getProxyBaseUrl();
  return `${proxyBaseUrl}/api/proxy-image?url=${encodeURIComponent(originalUrl)}`;
};
/**
 * Intercepta todas las imágenes de WordPress y las reemplaza con el proxy
 */
export const interceptWordPressImages = (): void => {
  // Interceptar imágenes existentes
  const images = document.querySelectorAll('img');
  images.forEach((img) => {
    const src = img.getAttribute('src');
    if (src && !src.startsWith('blob:') && !src.startsWith('data:') && src.includes(wordpressDomain) && !src.includes('/api/proxy-image')) {
      const proxyUrl = getProxyUrl(src);
      img.setAttribute('src', proxyUrl);
    }
  });
  // Interceptar imágenes que se agreguen dinámicamente usando MutationObserver
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as HTMLElement;
          // Verificar si el nodo agregado es una imagen
          if (element.tagName === 'IMG') {
            const img = element as HTMLImageElement;
            const src = img.getAttribute('src');
            if (src && !src.startsWith('blob:') && !src.startsWith('data:') && src.includes(wordpressDomain) && !src.includes('/api/proxy-image')) {
              const proxyUrl = getProxyUrl(src);
              img.setAttribute('src', proxyUrl);
            }
          }
          // Verificar si el nodo agregado contiene imágenes
          const images = element.querySelectorAll('img');
          images.forEach((img) => {
            const src = img.getAttribute('src');
            if (src && !src.startsWith('blob:') && !src.startsWith('data:') && src.includes(wordpressDomain) && !src.includes('/api/proxy-image')) {
              const proxyUrl = getProxyUrl(src);
              img.setAttribute('src', proxyUrl);
            }
          });
        }
      });
    });
  });
  // Observar cambios en el DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  // Interceptar cambios en el atributo src de imágenes existentes
  const imageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        const img = mutation.target as HTMLImageElement;
        const src = img.getAttribute('src');
        if (src && !src.startsWith('blob:') && !src.startsWith('data:') && src.includes(wordpressDomain) && !src.includes('/api/proxy-image')) {
          const proxyUrl = getProxyUrl(src);
          img.setAttribute('src', proxyUrl);
        }
      }
    });
  });
  // Observar cambios en atributos de todas las imágenes
  images.forEach((img) => {
    imageObserver.observe(img, {
      attributes: true,
      attributeFilter: ['src']
    });
  });
};
